export enum SessionKey {
  // Vendor lists are organization-specific, so the organization id is appended to this prefix to form the cache key.
  VENDOR_LIST_PREFIX = "VENDOR_LIST_",
}
